import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import AudioVisualizer from "./AudioVisualizer";

function TeamTabs({ teamData }) {
    const [show, setShow] = useState(false);

    const categories = useMemo(() => {
        const unique = [];

        teamData?.forEach((item) => {
            const category = item?.team_kategorien;

            if (
                category &&
                !unique.find((cat) => cat.id === category.id)
            ) {
                unique.push(category);
            }
        });

        return unique;
    }, [teamData]);

    // default active tab
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        if (categories?.length > 0 && !activeTab) {
            setActiveTab(categories[1]?.Titel);
        }
    }, [categories, activeTab]);

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".tab-content .col-inner h4"
            );

            let maxH4 = 0;
            headings?.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings?.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };

        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const [count, setCount] = useState(0)

    const handleCount = () => {
        setCount((prev) => prev + 1);
    }

    useEffect(() => {
        if (count === 3) {
            setShow(true);
            setCount(0)
        }
    }, [count]);

    const filteredMembers = useMemo(() => {
        return teamData?.filter(
            (member) => member?.team_kategorien?.Titel === activeTab
        );
    }, [teamData, activeTab]);

    useEffect(() => {
        if (!teamData?.length) return;

        teamData.forEach((member) => {
            if (!member?.Bild?.url) return;

            const img = new Image();

            img.src = `https://backend.bgzurlinden.ch${member?.Bild?.url}`;
        });
    }, [teamData]);

    return (
        <div className="tab_wrapper team_tabs">
            {show && (
                <div className="modal team_music_modal show d-block">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button className="btn-close" onClick={() => setShow(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" nighteye="disabled">
                                        <rect width="64" height="64" rx="32" fill={`var(--pink)`} />
                                        <rect x="19.3203" y="21.1396" width="2.56" height="33.28" rx="1.28" transform="rotate(-45 19.3203 21.1396)" fill="white" />
                                        <rect x="42.8594" y="19.3301" width="2.56" height="33.28" rx="1.28" transform="rotate(45 42.8594 19.3301)" fill="white" />
                                    </svg>
                                </button>
                                <div className='popup-container'>
                                    <div className="row">
                                        <div className="col-md-5 img_col mb-4 mb-md-0">
                                            <img src="images/music-image.png" className="w-100" />
                                        </div>
                                        <div className="col-md-7 content_col align-self-center">
                                            <div className="align_col_content">
                                                <h3 className="text-blue fs_35 fw-550 mb-4 mb-lg-5">Radio 200000 Langschtrass</h3>
                                                <div className="sound_control">
                                                    <AudioVisualizer />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Nav Tabs */}
            <div className="tabs-view-flex sec-pink-color">
                <h2 className="text-darkgrey">Unsere Teams</h2>

                <ul className="nav nav-tabs">
                    {categories?.map((category) => (
                        <li
                            className="nav-item"
                            key={category?.id}
                        >
                            <button
                                className={`nav-link ${activeTab === category?.Titel
                                    ? "active"
                                    : ""
                                    }`}
                                onClick={() =>
                                    setActiveTab(category?.Titel)
                                }
                            >
                                {category?.Titel}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Tab Content */}
            <div className="tab-content mt-4">
                <div className="tab-pane active">
                    <div className="row default-grid-gap team-new-row">
                        {filteredMembers?.map((member, index) => (
                            <div key={member?.id || index} className={`col-6 col-md-4 col-lg-3 col-item ${member?.team_kategorien?.Titel?.toLowerCase() != "externe hauswartung" ? 'mt-4' : ''}`}
                            >
                                {member?.team_kategorien?.Titel?.toLowerCase() != "externe hauswartung" ? (
                                    <figure>
                                        <div className="image-wrapper">
                                            <img
                                                src={`https://backend.bgzurlinden.ch${member?.Bild?.url}`}
                                                alt={member?.Name}
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        </div>

                                        {member?.Name === "Kaspar Niederberger" && (
                                            <button
                                                className="hidden_music_btn"
                                                onClick={handleCount}
                                            ></button>
                                        )}

                                        <figcaption className={`${(member?.Hat_Email !== "Ja" && member?.Hat_Telefon !== "Ja") ? 'p-0' : ''}`}>
                                            {member?.Name && (
                                                <h4 className="fs_26 fw-550 text-darkgrey">
                                                    {member?.Name}
                                                </h4>
                                            )}

                                            {/* {member?.Designation && (
                                                <p>{member?.Designation}</p>
                                            )} */}

                                            {member?.Designation && (
                                                <p>
                                                    {member.Designation.split("\n").map((line, index) => (
                                                        <React.Fragment key={index}>
                                                            {line}
                                                            <br />
                                                        </React.Fragment>
                                                    ))}
                                                </p>
                                            )}

                                            {(member?.Hat_Email === "Ja" || member?.Hat_Telefon === "Ja") && <div className="team_member_social">
                                                {member?.Hat_Email === "Ja" &&
                                                    <a href={`mailto:${member?.Email}`}>
                                                        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="30.5" cy="30.5" r="30" stroke="inherit"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M45.751 22.1577L35.1895 31.0107L45.751 39.8638V22.1577ZM45.2233 41.2422C44.929 41.5167 44.5357 41.6859 44.107 41.6859H15.8784C15.4511 41.6859 15.0592 41.5181 14.7663 41.2465L25.8911 31.9212L27.5903 33.3463C28.2595 33.9066 29.1353 34.1854 30.0068 34.1811C30.8769 34.1769 31.7541 33.8924 32.4276 33.3264L34.1042 31.9212L45.2233 41.2422ZM14.2344 39.8712L24.8061 31.0109L14.2344 22.1505V39.8712ZM14.7664 20.7754C15.0592 20.5023 15.4511 20.3359 15.8784 20.3359H44.1071C44.5372 20.3359 44.9305 20.5052 45.2234 20.7797L33.6686 30.4661L33.6531 30.4789L31.5394 32.251C31.1206 32.6023 30.5631 32.7786 30.0029 32.7815C29.444 32.7843 28.8908 32.6136 28.4805 32.2709L26.3442 30.4803L26.3258 30.4647L14.7664 20.7754Z" fill="inherit"/>
                                                        </svg>
                                                    </a>}
                                                {member?.Hat_Telefon === "Ja" &&
                                                    <a href={`tel:${member?.Telefon}`}>
                                                        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="30.5" cy="30.5" r="30" stroke="inherit"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7172 18.0957C16.8538 16.7472 18.4952 15.8805 20.1529 15.3487C21.199 15.0125 22.2506 15.5754 22.7379 16.5204L24.9679 20.8414C26.1719 23.1754 24.1147 23.6559 22.6771 25.7983C22.3586 26.2735 21.959 27.0051 22.2924 27.5707C25.1744 32.4654 28.5354 35.8268 33.43 38.7085C34.4465 39.3066 36.1729 37.5747 36.8222 36.9226C37.9521 35.786 38.6459 35.2515 40.1605 36.0331L44.4814 38.2631C45.4263 38.7504 45.9892 39.8019 45.6531 40.8481C44.584 44.177 42.3675 46.812 38.6378 46.7661C29.1361 46.65 14.351 31.8646 14.2349 22.3641C14.216 20.7766 14.6899 19.3148 15.7172 18.0957ZM30.9435 17.2412C38.0221 17.2412 43.7592 22.9784 43.7592 30.0571C43.7592 31.3679 45.7502 31.3679 45.7502 30.0571C45.7502 21.8795 39.1209 15.25 30.9434 15.25C29.6327 15.25 29.6328 17.2412 30.9435 17.2412ZM30.9435 26.9093C32.6821 26.9093 34.0914 28.3186 34.0914 30.0573C34.0914 31.368 36.0825 31.368 36.0825 30.0573C36.0825 27.2198 33.7823 24.9182 30.9436 24.9182C29.6328 24.9182 29.6328 26.9093 30.9435 26.9093ZM30.9435 22.0754C35.3523 22.0754 38.9254 25.6486 38.9254 30.0575C38.9254 31.3682 40.9165 31.3682 40.9165 30.0575C40.9165 24.5497 36.4511 20.0846 30.9438 20.0846C29.633 20.0846 29.6328 22.0754 30.9435 22.0754Z" fill="inherit"/>
                                                        </svg>
                                                    </a>}
                                            </div>}
                                        </figcaption>
                                    </figure>
                                ) : (
                                    <div class="item-inner">
                                        <img src={member?.Bild?.url ? `https://backend.bgzurlinden.ch${member?.Bild?.url}` : "images/team-icon.svg"} className="icon-icon" alt={member?.Name} />
                                        <h4 class="fs_26 fw-550 text-darkgrey position-relative pe-5">{member?.Name}
                                            {(member?.Hat_Email === "Ja" || member?.Hat_Telefon === "Ja") && <div className="team_member_social">
                                                {member?.Hat_Email === "Ja" &&
                                                    <a href={`mailto:${member?.Email}`}>
                                                        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="30.5" cy="30.5" r="30" stroke="inherit"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M45.751 22.1577L35.1895 31.0107L45.751 39.8638V22.1577ZM45.2233 41.2422C44.929 41.5167 44.5357 41.6859 44.107 41.6859H15.8784C15.4511 41.6859 15.0592 41.5181 14.7663 41.2465L25.8911 31.9212L27.5903 33.3463C28.2595 33.9066 29.1353 34.1854 30.0068 34.1811C30.8769 34.1769 31.7541 33.8924 32.4276 33.3264L34.1042 31.9212L45.2233 41.2422ZM14.2344 39.8712L24.8061 31.0109L14.2344 22.1505V39.8712ZM14.7664 20.7754C15.0592 20.5023 15.4511 20.3359 15.8784 20.3359H44.1071C44.5372 20.3359 44.9305 20.5052 45.2234 20.7797L33.6686 30.4661L33.6531 30.4789L31.5394 32.251C31.1206 32.6023 30.5631 32.7786 30.0029 32.7815C29.444 32.7843 28.8908 32.6136 28.4805 32.2709L26.3442 30.4803L26.3258 30.4647L14.7664 20.7754Z" fill="inherit"/>
                                                        </svg>
                                                    </a>}
                                                {member?.Hat_Telefon === "Ja" &&
                                                    <a href={`tel:${member?.Telefon}`}>
                                                        <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="30.5" cy="30.5" r="30" stroke="inherit"/>
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7172 18.0957C16.8538 16.7472 18.4952 15.8805 20.1529 15.3487C21.199 15.0125 22.2506 15.5754 22.7379 16.5204L24.9679 20.8414C26.1719 23.1754 24.1147 23.6559 22.6771 25.7983C22.3586 26.2735 21.959 27.0051 22.2924 27.5707C25.1744 32.4654 28.5354 35.8268 33.43 38.7085C34.4465 39.3066 36.1729 37.5747 36.8222 36.9226C37.9521 35.786 38.6459 35.2515 40.1605 36.0331L44.4814 38.2631C45.4263 38.7504 45.9892 39.8019 45.6531 40.8481C44.584 44.177 42.3675 46.812 38.6378 46.7661C29.1361 46.65 14.351 31.8646 14.2349 22.3641C14.216 20.7766 14.6899 19.3148 15.7172 18.0957ZM30.9435 17.2412C38.0221 17.2412 43.7592 22.9784 43.7592 30.0571C43.7592 31.3679 45.7502 31.3679 45.7502 30.0571C45.7502 21.8795 39.1209 15.25 30.9434 15.25C29.6327 15.25 29.6328 17.2412 30.9435 17.2412ZM30.9435 26.9093C32.6821 26.9093 34.0914 28.3186 34.0914 30.0573C34.0914 31.368 36.0825 31.368 36.0825 30.0573C36.0825 27.2198 33.7823 24.9182 30.9436 24.9182C29.6328 24.9182 29.6328 26.9093 30.9435 26.9093ZM30.9435 22.0754C35.3523 22.0754 38.9254 25.6486 38.9254 30.0575C38.9254 31.3682 40.9165 31.3682 40.9165 30.0575C40.9165 24.5497 36.4511 20.0846 30.9438 20.0846C29.633 20.0846 29.6328 22.0754 30.9435 22.0754Z" fill="inherit"/>
                                                        </svg>
                                                    </a>}
                                            </div>}
                                        </h4>
                                        {member?.Designation && (
                                            <p>
                                                {member.Designation.split("\n").map((line, index) => (
                                                    <React.Fragment key={index}>
                                                        {line}
                                                        <br />
                                                    </React.Fragment>
                                                ))}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeamTabs;